import type { ReactNode } from 'react';

interface AppHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * Unified app header component with consistent safe-area padding
 * and sticky positioning. Use this across all pages for consistency.
 */
function AppHeader({ children, className = '' }: AppHeaderProps) {
  return (
    <header className={`sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-neutral-200/50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-[env(safe-area-inset-top)] pb-2">
        {children}
      </div>
    </header>
  );
}

export default AppHeader;
